CF.ready(function() {
    const labelTermAndConditions = document.querySelector('.cf-field.create-account label > span');
    const divUrlDataCGV = document.querySelector('.cgv-url-data');
    const spanElement = document.getElementById("108809label");
    
    if (spanElement && spanElement.hasAttribute("aria-hidden")) {
        spanElement.removeAttribute("aria-hidden");
    }
    
    labelTermAndConditions.innerHTML = `${divUrlDataCGV.dataset.cgvTitleOne} <a href="${divUrlDataCGV.dataset.cgvLink}" target="_blank" class="hover-green" style="text-decoration:underline; text-underline-offset:2px; color:#000">${divUrlDataCGV.dataset.cgvTextLink}</a>${divUrlDataCGV.dataset.cgvTitleTwo}`;
    
    /* FORM CF CUSTOM */
    let myForm = document.querySelector('form[data-cf-form]');
    let cfForm = myForm.cfForm;
    let firstName = '';
    let lastName = '';
    let userNameValue = '';

    /* Email Validation */
    let validationEmail = {
        comparator: function isValid(fieldValue) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue);
        },
        errorMessage: "The email address format is incorrect!"
    };
    cfForm.addValidator(validationEmail, 'email');

    // New code: Full Name Validation
    let fullNameValidate = {
        comparator: function isValid(fieldValue) {
            return /^[\p{Letter}\s\-._']+$/u.test(fieldValue);
        },
        errorMessage: "Please use alphanumerical characters, accents, and special characters (\"-\", \"_\", \".\") only!"
    };
    cfForm.addValidator(fullNameValidate, 'last_name');// New code: Added full name validator

    /* Submit Button Text */
    const hostName = window.location.host;
    const submitText = hostName.includes('fr.') ? 'Soumettre' : 'Submit';
    
    $('form[data-cf-form]').find('.cf-submit-form').after(`
        <button type="button" class="custom-button cf-button btn button">
            <span>${submitText}</span>
            <div class="loader signup-loader-submit signup-loader-submit-popup">
                <div></div><div></div><div></div><div></div>
            </div>
        </button>
    `);

    function generatePassword() {
        const length = 8;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@$&*-_+";
        let retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    const buttonElm = document.querySelector('.custom-button.cf-button');
  
    buttonElm.addEventListener('click', function(e) {
        e.preventDefault();
        $('.custom-button.cf-button').find('.loader').addClass('active')
        const passwordGenerate = generatePassword();
        myForm.cfForm.setFieldValue('password', passwordGenerate);
        myForm.cfForm.setFieldValue('nom_dutilisateur', userNameValue);
        $('button.cf-submit-form[type="submit"]').trigger('click');

      
    });

    setInterval(function(){
      if($('.cf-spinner').length > 0){
        $('.custom-button.cf-button').find('.loader').addClass('active')
      }else{
        $('.custom-button.cf-button').find('.loader').removeClass('active')
      }
    })



    /* Scroll to first error */
    const CFFormBtnSubmit = document.querySelector('.cf-form-actions button[type="submit"]');
    CFFormBtnSubmit.addEventListener('click', () => {
        userNameValue = firstName + lastName;

        if (userNameValue.length > 12) {
            userNameValue = userNameValue.slice(0, 8) + makeid(4);
        } else if (userNameValue.length < 8) {
            userNameValue += makeid(8 - userNameValue.length);
        }

        myForm.cfForm.setFieldValue('nom_dutilisateur', userNameValue);

        setTimeout(() => {
            const firstInvalidField = document.querySelector('.cf-field[data-cf-invalid="true"]');
            gsap.to(window, { duration: 0.3, scrollTo: { y: firstInvalidField, offsetY: 250 } });
        }, 200);
    });

    const labels = document.querySelectorAll('.cf-field.boutique-shopify label, .cf-field.create-account label, .cf-field[data-cf-field-id="223081"] label');
    for (const label of labels) {
        const emptySquare = document.createElement("div");
        const greenSquare = document.createElement("div");
        emptySquare.prepend(greenSquare);
        label.append(emptySquare);
    }

    initHtmlSelectCustomCF();

    function makeid(length) {
        let result = '';
        const characters = '0123456789';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    function initHtmlSelectCustomCF() {
        const fieldContainer = document.querySelectorAll('.cf-field.deadline-choice');
        fieldContainer.forEach((elm) => {
            const legendTag = elm.querySelector('legend');
            legendTag.insertAdjacentHTML('afterend', '<div class="select-custom-container"></div>');
            const selectCustomContainer = elm.querySelector('.select-custom-container');
            const allOptions = elm.querySelectorAll('.cf-enum-field__choice');
            const titleFirst = document.createElement('div');
            titleFirst.classList.add('select-custom-title-first');

            titleFirst.innerHTML = `<span>${elm.querySelectorAll('[data-cf-column-key="years_of_expertise_2"]').length > 0 ? yexpertFormDeafaultValue : hexpertFormDeafaultValue}</span>`;
            const svgChevronContainer = document.createElement('div');
            svgChevronContainer.classList.add('svg-chevron');
            svgChevronContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="11.3" viewBox="0 0 16.943 11.3"><path id="Tracé_13893" data-name="Tracé 13893" d="M0,0,7.057,7.057,0,14.114" transform="translate(15.528 1.414) rotate(90)" fill="none" stroke="#65d09a" stroke-miterlimit="10" stroke-width="4"/></svg>`;

            titleFirst.append(svgChevronContainer);
            selectCustomContainer.prepend(titleFirst);

            // titleFirst.addEventListener('click', () => {
            //     document.querySelectorAll('.cf-field.deadline-choice').forEach(element => {
            //         element.classList.remove('active');
            //     });
            //     elm.classList.toggle('active');

            //     const titleFirstSpan = titleFirst.querySelector('span');
            //     const spanTitleFirstText = elm.classList.contains('active') ? 
            //         (elm.querySelectorAll('[data-cf-column-key="years_of_expertise_2"]').length > 0 ? yexpertFormDeafaultValue : hexpertFormDeafaultValue) :
            //         selectCustomContainer.classList.contains('checked-within') ? 
            //         elm.querySelector('.cf-enum-field__choice input:checked + span').innerText : 
            //         (elm.querySelectorAll('[data-cf-column-key="years_of_expertise_2"]').length > 0 ? yexpertFormDeafaultValue : hexpertFormDeafaultValue);
                
            //     titleFirstSpan.innerText = spanTitleFirstText;
            // });

          titleFirst.addEventListener('click', (event) => {
              event.stopPropagation(); // Prevent the document click event from firing immediately
          
              // Toggle the active class
              if (elm.classList.contains('active')) {
                  elm.classList.remove('active');
              } else {
                  document.querySelectorAll('.cf-field.deadline-choice').forEach(element => {
                      element.classList.remove('active');
                  });
                  elm.classList.add('active');
              }
          
              // Update the title text
              const titleFirstSpan = titleFirst.querySelector('span');
              const spanTitleFirstText = elm.classList.contains('active') ? 
                  (elm.querySelectorAll('[data-cf-column-key="years_of_expertise_2"]').length > 0 ? yexpertFormDeafaultValue : hexpertFormDeafaultValue) :
                  selectCustomContainer.classList.contains('checked-within') ? 
                  elm.querySelector('.cf-enum-field__choice input:checked + span').innerText : 
                  (elm.querySelectorAll('[data-cf-column-key="years_of_expertise_2"]').length > 0 ? yexpertFormDeafaultValue : hexpertFormDeafaultValue);
              
              titleFirstSpan.innerText = spanTitleFirstText;
          });

            allOptions.forEach(option => {
                selectCustomContainer.appendChild(option);
                option.addEventListener('click', function(e) {
                    if (e.target.type === 'radio') {
                        titleFirst.innerHTML = `<span>${e.target.value}</span><div class="svg-chevron">${svgChevronContainer.innerHTML}</div>`;
                        elm.classList.remove('active');
                        elm.querySelector('fieldset').classList.add('active');
                        selectCustomContainer.classList.add('checked-within');
                    }
                });
            });
        });
    }
  

    
    // Click outside to remove 'active'
    document.addEventListener('click', (event) => {
        document.querySelectorAll('.cf-field.deadline-choice').forEach(elm => {
            if (!elm.contains(event.target)) {
                elm.classList.remove('active');
            }
        });
    });
  


    myForm.addEventListener('cf:field_changed', function(event) {
        const fieldId = event.detail.fieldId;
        const columnKey = event.detail.columnKey;
        const value = event.detail.value;

        if (columnKey === 'last_name') {
            lastName = value;
        }
        if (columnKey === 'first_name') {
            firstName = value;
        }
        if(columnKey == 'email'){
          emailValue = value;
        }
    });

    myForm.addEventListener('cf:form_submitted', function(event) {
      window.location.href = '/pages/expert-form-success';
      $('#password_reset_email').val(emailValue);
      $('#password-reset-ajax-form').find('[type="submit"]').trigger('click');
    });

    /* Email already exists */
    myForm.addEventListener('cf:form_submission_failed', function(event) {
        const errors = event.detail.errors;
        if (errors.email[0] === 'has already been taken') {
            const errorEmailAlreadyExists = document.getElementById('email-exist-error') || createEmailErrorElement();
            errorEmailAlreadyExists.style.display = "block";
            gsap.to(window, { duration: 0.6, scrollTo: { y: '#email-exist-error', offsetY: 200 } });
        }

        // if(errors.email){
        //   var emailErrors = errors.email
        //   $('[data-cf-field-type="email"]').attr('data-cf-invalid', true);
        //   // $('[data-cf-field-type="email"]').find('ul').find('li').html("{{ 'blogs.Signup_popin_labels.already_used_email_address' | t  }} <span class='connect-email-exist'>{{ 'blogs.Signup_popin_labels.signin_invitation' | t }}</span>");
        //   $('.cf-field[data-cf-field-type="email"]').append(
        //     '<ul class="cf-field-errors">' +
        //     '<li>' +
        //     '<div data-reach-alert="true">' +
        //     '{{ \'blogs.Signup_popin_labels.already_used_email_address\' | t }} ' +
        //     '<span class="connect-email-exist">{{ \'blogs.Signup_popin_labels.signin_invitation\' | t }}</span>' +
        //     '</div>' +
        //     '</li>' +
        //     '</ul>'
        //   );
        //   const connectEmailExist = document.querySelector('.connect-email-exist');
        //   connectEmailExist.addEventListener('click', () => {
        //       $('.data-container').addClass('hidden');
        //       $('.signin_data').removeClass('hidden');
        //       var emailValue = $('[data-cf-column-key="email"]').val();
        //       $('#login_email_popup').val(emailValue);
        //   })
        // }
      
    });

   let emailValue = '';

    function createEmailErrorElement() {
        const cfFieldMail = document.querySelector('.cf-field[data-cf-field-type="email"]');
        const errorList = document.createElement('ul');
        errorList.classList.add('cf-field-errors');
        errorList.setAttribute('id', 'email-exist-error');
        const errorLi = document.createElement('li');
        const divError = document.createElement('div');
        divError.innerHTML = emailAlreadyBeen;
        errorLi.appendChild(divError);
        errorList.appendChild(errorLi);
        cfFieldMail.appendChild(errorList);
        return errorList;
    }

    myForm.addEventListener('cf:field_validated', function(event) {
        const errors = event.detail.errors;
        if (errors.length === 0) {
            event.target.classList.add('valid');
        } else {
            event.target.classList.remove('valid');
            const errorEmailAlreadyExists = document.getElementById('email-exist-error');
            if (errorEmailAlreadyExists) {
                errorEmailAlreadyExists.style.display = "none";
            }
        }
    });
});

document.querySelector('.expert-button-click').addEventListener('click', function() {
    window.scrollTo({
        top: document.querySelector('.expert-form-container').offsetTop,
        behavior: 'smooth'
    });
});
